<template>
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <card shadow type="secondary" class="border-0 mb-0">
        <template slot="header">
          <div class="text-center">
            <h2 class="text-dark">Data Deletion Instructions</h2>
            <p class="text-muted">How to delete your data from Quran Clip Helper</p>
          </div>
        </template>

        <div class="px-lg-4">
          <h4>Automatic Data Deletion</h4>
          <p>Quran Clip Helper is designed with privacy in mind. Most of your data is automatically deleted:</p>

          <div class="table-responsive">
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>Data Type</th>
                  <th>Retention Period</th>
                  <th>Deletion Method</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Uploaded Audio Files</td>
                  <td>Deleted after processing</td>
                  <td>Automatic</td>
                </tr>
                <tr>
                  <td>Uploaded Images/Videos</td>
                  <td>Deleted after processing</td>
                  <td>Automatic</td>
                </tr>
                <tr>
                  <td>Generated Videos</td>
                  <td>Deleted after download or timeout</td>
                  <td>Automatic</td>
                </tr>
                <tr>
                  <td>Job Records</td>
                  <td>Anonymized (IP hashed)</td>
                  <td>Automatic hashing</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h4 class="mt-4">Request Manual Data Deletion</h4>
          <p>If you would like to request deletion of any data associated with your usage, please follow these steps:</p>

          <div class="card bg-light p-4 mb-4">
            <h5>Step 1: Send an Email Request</h5>
            <p>Email us at <a href="mailto:moazelsayedquran@gmail.com">moazelsayedquran@gmail.com</a> with the subject line: <strong>"Data Deletion Request"</strong></p>
            
            <h5 class="mt-3">Step 2: Include Required Information</h5>
            <p>In your email, please include:</p>
            <ul>
              <li>The approximate date(s) you used the service</li>
              <li>The type of data you want deleted (if specific)</li>
              <li>Any other identifying information that can help us locate your data</li>
            </ul>

            <h5 class="mt-3">Step 3: Confirmation</h5>
            <p>We will respond to your request within 7 business days to confirm the deletion of your data.</p>
          </div>

          <h4>What We Cannot Delete</h4>
          <ul>
            <li><strong>Aggregated Analytics:</strong> Anonymous, aggregated statistics that cannot be traced back to you</li>
            <li><strong>Already Deleted Data:</strong> Files that have already been automatically removed from our servers</li>
          </ul>

          <h4>Opting Out of Analytics</h4>
          <p>To prevent future data collection through Google Analytics:</p>
          <ol>
            <li>Install the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">Google Analytics Opt-out Browser Add-on</a></li>
            <li>Use browser privacy settings to block third-party cookies</li>
            <li>Use private/incognito browsing mode</li>
          </ol>

          <h4>Facebook/Meta Data Deletion</h4>
          <p>If you accessed Quran Clip Helper through Facebook or any Meta service, you can also manage your data through:</p>
          <ol>
            <li>Go to your Facebook Settings</li>
            <li>Navigate to "Apps and Websites"</li>
            <li>Find Quran Clip Helper (if listed) and remove it</li>
            <li>Contact us directly for complete data removal</li>
          </ol>

          <h4>Contact Us</h4>
          <p>For any questions about data deletion or privacy, please contact:</p>
          <ul>
            <li>Email: <a href="mailto:moazelsayedquran@gmail.com">moazelsayedquran@gmail.com</a></li>
            <li>Instagram: <a href="https://instagram.com/moazquran" target="_blank">instagram.com/moazquran</a></li>
          </ul>

          <div class="alert alert-info mt-4">
            <strong>Note:</strong> We take your privacy seriously. Since we automatically delete most user data after processing, there may be nothing to delete by the time you submit a request. We will always confirm what data, if any, we were able to locate and remove.
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataDeletion'
}
</script>
